import { SiteNavigationType } from "../../Utilities/ViewModels/SiteNavigationType";
import TripRateCalculationFiltersViewModel from "./TripRateCalculationFiltersViewModel";

export default class SiteFilterViewModel {
    references: string[] | null = null;
    removedSurveys: RemovedSurvey[] | null = null;
    showOnlySelected: boolean = false;
    partialSiteName: string = '';
    partialTownName: string = '';
    locationArea: string = '';
    locationSubArea: string = '';
    useClass: string = '';
    parkingAreaMin: string = '';
    parkingAreaMax: string = '';
    variablePar1Min: string = '';
    variablePar1Max: string = '';
    variablePar2Min: string = '';
    variablePar2Max: string = '';
    tripRateFilters: TripRateCalculationFiltersViewModel | null = null
    type: SiteNavigationType | null = null
}

export type RemovedSurvey = {
    reference: string;
    reason: string;
};